import { Euler, Quaternion, Vector3 } from "three";

export function resolveFacingQuaternionAfterMove(
  fromPosition: Vector3,
  toPosition: Vector3,
  snap = true
) {
  const targetQuaternion = new Quaternion();
  const targetEuler = new Euler(
    0,
    Math.PI / 2 -
      Math.atan2(toPosition.z - fromPosition.z, toPosition.x - fromPosition.x)
  );
  if (snap) {
    const targetInHalfTurns = targetEuler.y / (Math.PI * 0.5);
    targetEuler.y = Math.round(targetInHalfTurns) * Math.PI * 0.5;
  }
  targetQuaternion.setFromEuler(targetEuler);
  return targetQuaternion;
}
